module.exports = __webpack_public_path__ + "static/audiobear-6b65abfbee7314d2a9de01141d63e24e.jpg";